module.exports = __webpack_public_path__ + "static/assets/img/video2.5ccbb5b5.gif";